import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import CardWrap from "@/components/common/CardWrap.vue";
import CardHeader from "./CardHeader.vue";
import CardContractInfo from "./CardContractInfo.vue";
import CardInvoiceInfo from "./CardInvoiceInfo.vue";
import CardInvoiceTable from "./CardInvoiceTable.vue";
import { ICompanyInvoice } from "@/models/company-invoice";

interface IProps {
  companyInvoice: ICompanyInvoice;
  remainCompanyInvoices: ICompanyInvoice[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    companyInvoice: {},
    remainCompanyInvoices: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardWrap, null, {
    default: _withCtx(() => [
      _createVNode(CardHeader, {
        "company-invoice": _ctx.companyInvoice,
        "remain-company-invoices": _ctx.remainCompanyInvoices
      }, null, 8, ["company-invoice", "remain-company-invoices"]),
      _createVNode(CardContractInfo, { "company-invoice": _ctx.companyInvoice }, null, 8, ["company-invoice"]),
      _createVNode(CardInvoiceInfo, { "company-invoice": _ctx.companyInvoice }, null, 8, ["company-invoice"]),
      _createVNode(CardInvoiceTable, { "company-invoice": _ctx.companyInvoice }, null, 8, ["company-invoice"])
    ]),
    _: 1
  }))
}
}

})